import { get } from "svelte/store";
import { settingsStore } from "../lib/stores/settings";
import { getSearchParam } from "../lib/helpers/document";
import { isEditorMode } from "../lib/stores/mode";
import {
  multipleItemsMultipleVariationsCampaignUserResponse,
  noMenuCampaignUserResponse
} from "./campaignUserResponses";
import { updateSession } from "../lib/stores/session";
import uniq from "lodash/uniq";
import Pizza from "./assets/pizza.svg";

type ConfigMenuItem = {
  visible_name: string;
  visible_variation: string;
  visible_variation_2?: string;
  description: string;
  image?: string;
  name: string;
  variation: string;
}

export const DummyMenuBuilder = {
  buildAvailableItems: (menuItems: ConfigMenuItem[]) => {
    return menuItems.map((item) => ({
      note: null,
      image: item.image,
      is_fragile: false,
      distance: 949721,
      prize_value: 0,
      pickup_location: {
        api: "manual",
        netsuite_location_id: null,
        location_key: "delivery-(38.0469061,-84.4962626)-manual",
        latitude: 38.0469061,
        longitude: -84.4962626
      },
      variation_key: item.variation,
      item_key: `${item.name}|notthatgreat|delivery-(38.0469061,-84.4962626)-manual`,
      count: 4,
      weight: 0,
      description: item.description,
      team_id: null,
      block_name: "delivery",
      visible_name: item.visible_name,
      visible_variation: item.visible_variation,
      visible_variation_2: item.visible_variation_2,
      name_key: item.name,
      netsuite_item_id: null,
      price: 0,
      workflow_key: "notthatgreat",
      netsuite_location_id: null,
      location_key: "delivery-(38.0469061,-84.4962626)-manual"
    }));
  },
  buildMenuResponse: (menus: Record<string, ConfigMenuItem[]>, requiredSelectionCount?: number) => {
    const menu = getSearchParam("menu");
    const menuKeys = Object.keys(menus);

    const selectedMenu = menu && menuKeys.includes(menu)
      ? menus[menu]
      : menus[menuKeys[Math.floor(Math.random() * menuKeys.length)]]; // Random menu, for most cases there's only one

    const availableItems = DummyMenuBuilder.buildAvailableItems(selectedMenu);

    const result = {
      ...multipleItemsMultipleVariationsCampaignUserResponse,
      metadata: {
        ...multipleItemsMultipleVariationsCampaignUserResponse.metadata,
        available_menu_items: availableItems,
        menu_items: selectedMenu
      } as Record<string, unknown>
    };

    if (requiredSelectionCount) {
      result.metadata.required_selection_count = requiredSelectionCount;
    }

    return result;
  },
  getStaticBundleItems: () => {
    const available = multipleItemsMultipleVariationsCampaignUserResponse.metadata.available_menu_items;
    const itemKeys = uniq(available.map((item) => item.item_key));

    return itemKeys.map((itemKey, index) => ({
      item_key: itemKey,
      variation_key: index % 2 === 0
        ? undefined
        : available.find((item) => item.item_key === itemKey)?.variation_key,
      count: 2
    }));
  },
  getRandomBundleItems: () => {
    const available = multipleItemsMultipleVariationsCampaignUserResponse.metadata.available_menu_items;
    const itemKeys = uniq(available.map((item) => item.item_key));

    return itemKeys.map((itemKey) => ({
      item_key: itemKey,
      variation_key: Math.random() > 0.5
        ? undefined
        : available.find((item) => item.item_key === itemKey)?.variation_key,
      count: Math.floor(Math.random() * 3) + 1
   }));
  },
  buildDummyBundleResponse: (menus: Record<string, ConfigMenuItem[]>) => {
    const menuResponse = DummyMenuBuilder.buildMenuResponse(menus);

    return {
      ...menuResponse,
      metadata: {
        ...menuResponse.metadata,
        social_gift_bundle: {
          image: Pizza,
          description: "A bundle of items",
          items: DummyMenuBuilder.getRandomBundleItems()
        }
      }
    };
  }
};

export const getMenuResponse = () => {
  const menus = get(settingsStore).menus as Record<string, ConfigMenuItem[]>;
  const isBundle = Boolean(getSearchParam("bundle"));
  const requiredSelectionCount = Number(getSearchParam("required_selection_count"));

  if (isBundle) {
    // FIXME: I guess we need to make sure the mode is bundle... setting it here
    // but it probably should be set elsewhere
    updateSession({ socialGiftingMode: "bundle" });

    const menuItems = multipleItemsMultipleVariationsCampaignUserResponse.metadata.menu_items;
    return DummyMenuBuilder.buildDummyBundleResponse(menus ?? { dummy: menuItems });
  } else if (menus) {
    return DummyMenuBuilder.buildMenuResponse(menus, requiredSelectionCount);
  } else if (isEditorMode()) {
    return multipleItemsMultipleVariationsCampaignUserResponse;
  } else {
    return noMenuCampaignUserResponse;
  }
};
